import { useGetSentimentsSummary } from '@/apis/agency/systemSentiment/hook';
import AvgResponseTimeIcon from '@/assets/icons/AvgResponseTimeIcon';
import CallNeedingAuditIcon from '@/assets/icons/CallNeedingAuditIcon';
import SentimentRecommendationIcon from '@/assets/icons/SentimentRecommendationIcon';
import ToolErrorIcon from '@/assets/icons/ToolErrorIcon';
import { formatMilliseconds } from '@/utils/helperFunctions';
import { Box, Grid2 as Grid, Stack, Typography, useTheme, Skeleton } from '@mui/material';

export default function Metrics({ filters }: { filters: Record<string, any> }) {
  const theme = useTheme();

  const { data: summary, isLoading } = useGetSentimentsSummary({
    filter: filters
  });

  const metricsCards = [
    {
      label: 'Calls Needing Audit',
      value: summary?.calls_needing_audit,
      icon: <CallNeedingAuditIcon />
    },
    {
      label: 'Tool Errors',
      value: summary?.tool_errors,
      icon: <ToolErrorIcon />
    },
    {
      label: 'Avg Response Time',
      value: summary?.avg_response_time ? formatMilliseconds(summary?.avg_response_time) : null,
      icon: <AvgResponseTimeIcon />
    },
    {
      label: 'AI Recommendation',
      value: summary?.ai_recommendations,
      icon: <SentimentRecommendationIcon />
    }
  ];

  return (
    <Grid container spacing={3} mb={3}>
      {metricsCards.map((card: any, idx: number) => (
        <Grid key={idx} size={3}>
          <Box
            p={2}
            border='1px solid #ECECEC'
            bgcolor='#fff'
            borderRadius={2}
            borderLeft={`3px solid ${theme.palette.primary.main}`}
          >
            <Stack direction='row' justifyContent='space-between'>
              {isLoading ? (
                <>
                  <Skeleton width={140} height={20} />
                  <Skeleton variant='circular' width={20} height={20} />
                </>
              ) : (
                <>
                  <Typography fontSize={14} fontWeight={600} color='text.secondary'>
                    {card.label}
                  </Typography>
                  {card.icon}
                </>
              )}
            </Stack>

            {isLoading ? (
              <Skeleton width={80} height={28} sx={{ mt: 1 }} />
            ) : (
              <Typography fontSize={20} fontWeight={500} mt={1}>
                {card.value ?? '-'}
              </Typography>
            )}
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}
